import { render, staticRenderFns } from "./deleteParkingSpaceApply.vue?vue&type=template&id=60afad34"
import script from "./deleteParkingSpaceApply.vue?vue&type=script&lang=js"
export * from "./deleteParkingSpaceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports